/* __next_internal_client_entry_do_not_use__ ShoppingBag auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1735))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:45:00.132Z
 */ export var ShoppingBag = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M22.0749 21.2401C22.1014 21.4797 22.0771 21.7221 22.0036 21.9517C21.93 22.1812 21.8089 22.3927 21.6481 22.5723C21.4873 22.7518 21.2904 22.8955 21.0704 22.9938C20.8503 23.0921 20.612 23.1429 20.3709 23.1429H3.6292C3.38816 23.1429 3.14982 23.0921 2.92974 22.9938C2.70967 22.8955 2.51281 22.7518 2.35201 22.5723C2.1912 22.3927 2.07008 22.1812 1.99653 21.9517C1.92299 21.7221 1.89868 21.4797 1.9252 21.2401L3.42863 7.71436H20.5715L22.0749 21.2401Z",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M7.71436 7.71432V5.14289C7.71436 4.00625 8.16588 2.91616 8.96961 2.11243C9.77334 1.30871 10.8634 0.857178 12.0001 0.857178C13.1367 0.857178 14.2268 1.30871 15.0305 2.11243C15.8343 2.91616 16.2858 4.00625 16.2858 5.14289V7.71432",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    ]
}), "ShoppingBag", function(strictLocalize) {
    return {
        viewBox: "0 0 24 24",
        titleAccess: strictLocalize({
            id: "tMvsU7",
            defaultMessage: [
                {
                    type: 0,
                    value: "Open shopping bag"
                }
            ]
        }),
        fill: "none",
        color: Core.icon.default
    };
});
